<script lang="ts">
    import WindVector from "../../../public/icons/wind_vector.svelte";
    import { conditions, cType, Observation, Widget, widgetInfo, WidgetType } from "../../store";

    export let isPrimaryCondition: boolean = false;

    let fill = "--default-color"
    let errorFill = "--error-color"
    let threshold = undefined;
    let conditionValue;
    let windDirection;
    let windSpeed;


    widgetInfo.subscribe((value: Widget) => {
        if (value) {
            if(value.type != WidgetType.DEF && isPrimaryCondition){
                fill = "--primary-color"
            }
            if (isPrimaryCondition && value.policies) { // NPA
                threshold = value.primaryThreshold;
            } else {
                const currentConditions = value.widgetConditions;
                const temperatureCondition = currentConditions.find(
                    condition => condition.conditionType === cType.WIND
                );
                if (temperatureCondition) {
                    threshold = temperatureCondition.threshold;
                }
            }
        }
    });

    conditions.subscribe((value: Observation) => {
        if(value && value.windSpeed){
            windSpeed = value.windSpeed.value;
            conditionValue = Math.round(windSpeed);
            windDirection = value.windDirection;

            if(threshold != undefined && windSpeed >= threshold)
                fill = errorFill;
        }
        else{
            conditionValue = "--";
        }
    });

</script>

<div class="cc-container" style="color: var({fill});">
    <div class="weatherIcon">
        <WindVector fill="var({fill})" direction={windDirection}/>
    </div>

    <div class="{isPrimaryCondition ? "primary-value":"value"}">
        <span>{conditionValue}</span>{#if windSpeed > 0 && windDirection}<span style="font-size:50%;">{windDirection}</span>{/if}
    </div>
    <div class="{isPrimaryCondition ? "primary-label" : "label"}">Wind</div>



  </div>
